import React, { useState, useEffect } from "react";

import Quiz from "./Components/Quiz";
import { BsBookmark } from "react-icons/bs";
import { AiOutlinePause } from "react-icons/ai";

import PATH from "../../../constants/routes";

import QuizMenu from "./Components/QuizMenu";
import { CgChevronLeftR, CgChevronRightR } from "react-icons/cg";
import { useNavigate, useParams } from "react-router-dom";
import ConfirmQuitModal from "./Modals/ConfirmQuitModal";
import QuizMenuModal from "./Modals/QuizMenuModal";
import { Helmet } from "react-helmet";

import "./PlayQuiz.scss";
import Timer from "./Components/Timer";
let newQuestions = [
  {
    id: 1632,
    module_id: "mbbs",
    subject: 3,
    question: "What is block in blockchain",
    optionA: "Data that contains a set of transactions and a unique code. ",
    optionB: "Block of wall of chain",
    optionC: "A physical object of block",
    optionD: "Block of data with links",
    description: `<p>In a blockchain, a block is a unit of data that contains a set of transactions and a unique code, called a hash, that distinguishes it from other blocks. A block is not a physical object and does not have a physical location. It is simply a record of data that is stored on the blockchain network.</p>

 
 <p>   A block is also not a single transaction. A block can contain multiple transactions, and each transaction is recorded separately within the block.</p>
    <img src="https://images.unsplash.com/photo-1671419742115-7cd22c6eae73?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1527&q=80"
    alt="mountains"/>
 <p>Additionally, a block is not the same as the blockchain itself. The blockchain is a distributed database that consists of a chain of blocks, with each block containing a hash that links it to the previous block. The block is just one part of the blockchain, and the blockchain is made up of many blocks connected together in a chain.</p>`,
    answer: 1,
    imgid: "",
    unit_id: 11,
    chapterId: 76,
    correct: 0,
    incorrect: 0,
  },
  {
    id: 163322,
    module_id: "mbbs",
    subject: 3,
    question: "Which of the following statements is wrong for viroids? ",
    optionA: "They lack a protein coat",
    optionB: "They are smaller than viruses",
    optionC: "They cause infections",
    optionD: "Their RNA is of high molecular weight",
    description:
      "Viroids, the smallest known pathogens, are naked, circular, single-stranded RNA molecules.",
    answer: 4,
    imgid: "",
    unit_id: 11,
    chapterId: 76,
    correct: 0,
    incorrect: 0,
  },
  {
    id: 1634114,
    module_id: "mbbs",
    subject: 3,
    question: "Which of the following shows coiled RNA strand and capsomeres? ",
    optionA: "Polio virus",
    optionB: "Tobacco masaic virus",
    optionC: "Measles virus",
    optionD: "Retrovirus",
    description:
      "TMV (Tobacco Mosaic Virus) is a rod-shaped virus. The rod has a core which contains helically coiled single stranded RNA. There is a protective covering of protein called capsid around the infectivepart. Capsid consists of small subunits called capsomeres and has antigenic property.",
    answer: 2,
    imgid: "",
    unit_id: 11,
    chapterId: 76,
    correct: 0,
    incorrect: 0,
  },
  {
    id: 1634321,
    module_id: "mbbs",
    subject: 3,
    question: "Which of the following shows coiled RNA strand and capsomeres? ",
    optionA: "Polio virus",
    optionB: "Tobacco masaic virus",
    optionC: "Measles virus",
    optionD: "Retrovirus",
    description:
      "TMV (Tobacco Mosaic Virus) is a rod-shaped virus. The rod has a core which contains helically coiled single stranded RNA. There is a protective covering of protein called capsid around the infectivepart. Capsid consists of small subunits called capsomeres and has antigenic property.",
    answer: 2,
    imgid: "",
    unit_id: 11,
    chapterId: 76,
    correct: 0,
    incorrect: 0,
  },
  {
    id: 1634123,
    module_id: "mbbs",
    subject: 3,
    question: "Which of the following shows coiled RNA strand and capsomeres? ",
    optionA: "Polio virus",
    optionB: "Tobacco masaic virus",
    optionC: "Measles virus",
    optionD: "Retrovirus",
    description:
      "TMV (Tobacco Mosaic Virus) is a rod-shaped virus. The rod has a core which contains helically coiled single stranded RNA. There is a protective covering of protein called capsid around the infectivepart. Capsid consists of small subunits called capsomeres and has antigenic property.",
    answer: 2,
    imgid: "",
    unit_id: 11,
    chapterId: 76,
    correct: 0,
    incorrect: 0,
  },
  {
    id: 163435,
    module_id: "mbbs",
    subject: 3,
    question: "Which of the following shows coiled RNA strand and capsomeres? ",
    optionA: "Polio virus",
    optionB: "Tobacco masaic virus",
    optionC: "Measles virus",
    optionD: "Retrovirus",
    description:
      "TMV (Tobacco Mosaic Virus) is a rod-shaped virus. The rod has a core which contains helically coiled single stranded RNA. There is a protective covering of protein called capsid around the infectivepart. Capsid consists of small subunits called capsomeres and has antigenic property.",
    answer: 2,
    imgid: "",
    unit_id: 11,
    chapterId: 76,
    correct: 0,
    incorrect: 0,
  },
  {
    id: 16342,
    module_id: "mbbs",
    subject: 3,
    question: "Which of the following shows coiled RNA strand and capsomeres? ",
    optionA: "Polio virus",
    optionB: "Tobacco masaic virus",
    optionC: "Measles virus",
    optionD: "Retrovirus",
    description:
      "TMV (Tobacco Mosaic Virus) is a rod-shaped virus. The rod has a core which contains helically coiled single stranded RNA. There is a protective covering of protein called capsid around the infectivepart. Capsid consists of small subunits called capsomeres and has antigenic property.",
    answer: 2,
    imgid: "",
    unit_id: 11,
    chapterId: 76,
    correct: 0,
    incorrect: 0,
  },
  {
    id: 163411,
    module_id: "mbbs",
    subject: 3,
    question: "Which of the following shows coiled RNA strand and capsomeres? ",
    optionA: "Polio virus",
    optionB: "Tobacco masaic virus",
    optionC: "Measles virus",
    optionD: "Retrovirus",
    description:
      "TMV (Tobacco Mosaic Virus) is a rod-shaped virus. The rod has a core which contains helically coiled single stranded RNA. There is a protective covering of protein called capsid around the infectivepart. Capsid consists of small subunits called capsomeres and has antigenic property.",
    answer: 2,
    imgid: "",
    unit_id: 11,
    chapterId: 76,
    correct: 0,
    incorrect: 0,
  },
  {
    id: 16346,
    module_id: "mbbs",
    subject: 3,
    question: "Which of the following shows coiled RNA strand and capsomeres? ",
    optionA: "Polio virus",
    optionB: "Tobacco masaic virus",
    optionC: "Measles virus",
    optionD: "Retrovirus",
    description:
      "TMV (Tobacco Mosaic Virus) is a rod-shaped virus. The rod has a core which contains helically coiled single stranded RNA. There is a protective covering of protein called capsid around the infectivepart. Capsid consists of small subunits called capsomeres and has antigenic property.",
    answer: 2,
    imgid: "",
    unit_id: 11,
    chapterId: 76,
    correct: 0,
    incorrect: 0,
  },
  {
    id: 16343,
    module_id: "mbbs",
    subject: 3,
    question: "Which of the following shows coiled RNA strand and capsomeres? ",
    optionA: "Polio virus",
    optionB: "Tobacco masaic virus",
    optionC: "Measles virus",
    optionD: "Retrovirus",
    description:
      "TMV (Tobacco Mosaic Virus) is a rod-shaped virus. The rod has a core which contains helically coiled single stranded RNA. There is a protective covering of protein called capsid around the infectivepart. Capsid consists of small subunits called capsomeres and has antigenic property.",
    answer: 2,
    imgid: "",
    unit_id: 11,
    chapterId: 76,
    correct: 0,
    incorrect: 0,
  },
  {
    id: 16340,
    module_id: "mbbs",
    subject: 3,
    question: "Which of the following shows coiled RNA strand and capsomeres? ",
    optionA: "Polio virus",
    optionB: "Tobacco masaic virus",
    optionC: "Measles virus",
    optionD: "Retrovirus",
    description:
      "TMV (Tobacco Mosaic Virus) is a rod-shaped virus. The rod has a core which contains helically coiled single stranded RNA. There is a protective covering of protein called capsid around the infectivepart. Capsid consists of small subunits called capsomeres and has antigenic property.",
    answer: 2,
    imgid: "",
    unit_id: 11,
    chapterId: 76,
    correct: 0,
    incorrect: 0,
  },
  {
    id: 1635,
    module_id: "mbbs",
    subject: 3,
    question: "Viruses have:",
    optionA: "DNA enclosed in a protein coat",
    optionB: "Prokaryotic nucleus",
    optionC: "Single chromosome",
    optionD: "Both DNA and RNA",
    description:
      "All viruses are nucleoproteins (Nucleic acid + Protein) in the structure. In a particular virus either DNA or RNA is  the genetic",
    answer: 1,
    imgid: "",
    unit_id: 11,
    chapterId: 76,
    correct: 0,
    incorrect: 0,
  },
];

let selectedAnswers = [
  // {
  //   id: 60,
  // questionId: 1632,
  //   chapterId: 76,
  //   selected: 2,
  //   flag: false,
  // },
];

export default function PlayQuiz(props) {
  const { isTest } = props;

  const { subject_id, topic_id } = useParams();
  const navigate = useNavigate();

  const [showQuizMenu, setShowQuizMenu] = useState(false);
  const [answeredList, setAnsweredList] = useState(selectedAnswers);

  const [questions, setQuestions] = useState(newQuestions);
  const [totalQuestion, setTotalQuestion] = useState<number>(
    newQuestions.length
  );
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const [showConfirmExitModal, setShowConfirmExitModal] =
    useState<boolean>(false);

  const handleBackButton = (event) => {
    event.preventDefault();
    handleQuitModalToggle(true);
  };

  useEffect(() => {
    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener("popstate", handleBackButton);

    return () => window.removeEventListener("popstate", handleBackButton);
  }, []);

  const handleQuitModalToggle = (status) => {
    if (status) {
      setShowConfirmExitModal(true);
    } else {
      setShowConfirmExitModal(false);
      window.history.pushState(null, null, window.location.pathname);
    }
  };

  const handleConfirmQuit = (status: Boolean) => {
    if (status) {
      console.log(
        "navigating",
        `../../${PATH.QBANK}/${subject_id}/${topic_id}/${PATH.PLAY_QUIZ_LINK}`
      );
      navigate(`../${subject_id}/${topic_id}/${PATH.QUIZ_STATUS_LINK}`, {
        replace: true,
      });
    } else {
      setShowConfirmExitModal(false);
      window.history.pushState(null, null, window.location.pathname);
    }
  };

  const handleToggleQuizMenu = () => {
    setShowQuizMenu((preState) => !preState);
  };

  const handleBoxClick = (selectedIndex) => {
    setCurrentIndex(selectedIndex);
  };

  const handleAnswerClick = (selectedAnswer) => {
    let answeredListCopy = Array.from(answeredList);
    answeredListCopy.push({
      selected: selectedAnswer,
      questionId: questions[currentIndex].id,
      flag: questions[currentIndex].answer === selectedAnswer,
      id: 100, //random
      chapterId: 123, //random
    });
    setAnsweredList(answeredListCopy);
    //check if answer is correct or not and push to array in selected
  };

  const handlePreviousClick = () => {
    //getting previous question
    if (currentIndex !== 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleNextClick = () => {
    if (currentIndex < questions.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const getSelectedAnswer = (questionId) => {
    let results = answeredList.filter((selectedAnswer) => {
      if (selectedAnswer.questionId === questionId) return selectedAnswer;
      else {
        return null;
      }
    });
    if (results.length) return results[0];
    return null;
  };

  const renderQuiz = () => {
    return (
      <Quiz
        selectedAnswer={getSelectedAnswer(questions[currentIndex].id)}
        question={questions[currentIndex]}
        handleAnswerClick={handleAnswerClick}
      />
    );
  };

  return (
    <div className="quiz_container">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Quiz</title>
      </Helmet>
      <div className="quiz_header_container">
        <div className="quiz_header">
          <p>
            Ques {currentIndex + 1} of {totalQuestion}
          </p>
          {isTest && (
            <div className="timer">
              <Timer maxTime={100} />
            </div>
          )}
          <div className="navigation_container">
            <CgChevronLeftR onClick={handlePreviousClick} />
            <CgChevronRightR onClick={handleNextClick} />
          </div>
          <div className="quiz_menu">
            <BsBookmark className="bookmark_icon" />
            <AiOutlinePause
              className="pause_icon"
              onClick={handleToggleQuizMenu}
            />
          </div>
        </div>
      </div>

      <div className="quiz_sidebar_container">
        <QuizMenu
          questions={questions}
          answeredList={answeredList}
          handleBoxClick={handleBoxClick}
          handleModalToggle={() => {}}
        />
      </div>

      <div className="quiz_body">{renderQuiz()}</div>
      <div className="button_wrapper">
        <div className="button button_secondary" onClick={handlePreviousClick}>
          Previous
        </div>
        <div className="button button_primary" onClick={handleNextClick}>
          Next
        </div>
      </div>

      {/* modals here */}
      <QuizMenuModal
        showModal={showQuizMenu}
        handleModalToggle={handleToggleQuizMenu}
        questions={questions}
        answeredList={answeredList}
        handleBoxClick={handleBoxClick}
      />
      <ConfirmQuitModal
        showModal={showConfirmExitModal}
        handleModalToggle={handleQuitModalToggle}
        handleConfirmQuit={handleConfirmQuit}
      />
    </div>
  );
}
